import { ucfirst } from '~/helpers'
import { steps as signupSteps } from 'mixins/SignupPageMixin'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireNonPhysicianMiddleware from 'middlewares/RequireNonPhysicianMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'
import DetectSignupStepMiddleware from 'middlewares/DetectSignupStepMiddleware'
import DetectActiveSessionMiddleware from 'middlewares/DetectActiveSessionMiddleware'
import DetectSuperAdminMiddleware from 'middlewares/DetectSuperAdminMiddleware'
import RequireDemoUser from 'middlewares/RequireDemoUser'

export default [
    {
        path: '/login',
        name: 'auth.login',
        view: 'auth/Login',
    },
    {
        path: '/forgot-password',
        name: 'auth.forgot-password',
        view: 'auth/ForgotPassword',
    },
    {
        path: '/reset-password',
        name: 'auth.reset-password',
        view: 'auth/ResetPassword',
    },
    {
        path: '/set-password',
        name: 'auth.set-password',
        view: 'auth/SetPassword',
    },
    {
        path: '/signup',
        name: 'auth.signup',
        redirect: { name: `auth.signup.${signupSteps[0]}` },
    },
    {
        path: '/verify-email',
        name: 'auth.verify-email',
        view: 'auth/VerifyEmail',
    },
    {
        path: `/signup/register`,
        name: `auth.signup.register`,
        view: `auth/signup/Register`,
    },
    {
        path: `/signup/update/demo`,
        name: `auth.signup.update.demo`,
        view: `auth/signup/UpdateDemo`,
        middlewares: [RequireDemoUser],
    },
    {
        path: `/signup/register/demo`,
        name: `auth.signup.register.demo`,
        view: `auth/signup/RegisterDemo`,
    },
    {
        path: `/signup/congratulations`,
        name: `auth.signup.congratulations`,
        view: `auth/signup/Congratulations`,
    },
    ...signupSteps.map((step) => ({
        path: `/signup/${step}`,
        name: `auth.signup.${step}`,
        view: `auth/signup/${ucfirst(step)}`,
        default: { params: { step } },
        middlewares: [
            DetectSuperAdminMiddleware,
            RequireUserMiddleware,
            DetectSignupStepMiddleware,
            DetectActiveSessionMiddleware,
        ],
    })),
    {
        path: '/select-physician',
        name: 'auth.select-physician',
        view: 'auth/SelectPhysician',
        middlewares: [RequireSignupFinishedMiddleware, RequireNonPhysicianMiddleware, RequireUserMiddleware],
    },
    {
        path: '/invite-member',
        name: 'auth.invite-member',
        view: 'auth/InviteMemberToPractice',
        middlewares: [RequireSignupFinishedMiddleware, RequireNonPhysicianMiddleware, RequireUserMiddleware],
    },
    {
        path: '/ehr-login',
        name: 'auth.ehr-login',
        view: 'auth/EhrLogin',
    },
    {
        path: '/signup/register-token',
        name: 'auth.register-token',
        view: 'auth/Tokens',
    },
    {
        path: '/external/propose-time',
        name: 'auth.external.propose-time',
        view: 'auth/ExternalProposeTime',
    },
]
